import React, {useState, useEffect, useRef} from "react";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { toast } from "react-toastify";
import { Button } from "@material-ui/core";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";

import { useStore } from "@store/store";
import { schema } from "@utils/schemas";
import validationSchema from "@utils/validationSchemas";
import {
  FETCH_CUSTOMERS,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILURE,
  FETCH_DRIVERS,
  FETCH_DRIVERS_SUCCESS,
  FETCH_DRIVERS_FAILURE,
  CREATE_INTERSTATE_JOB,
  CREATE_INTERSTATE_JOB_SUCCESS,
  CREATE_INTERSTATE_JOB_FAILURE,
  FETCH_PICK_UP_CTOS,
  FETCH_PICK_UP_CTOS_SUCCESS,
  FETCH_PICK_UP_CTOS_FAILURE,
  FETCH_DROP_OFF_CTOS,
  FETCH_DROP_OFF_CTOS_SUCCESS,
  FETCH_DROP_OFF_CTOS_FAILURE
} from "@utils/actionTypes";
import { routes, actionPermission } from "@utils/constant";
import API from "@services/axios";
import Popup from "./popup";
import { CreateJobStyle } from "./style";
import {
  getPermissions,
  isRolePermission,
  actionFromPermission
} from "@utils/commonFunctions";

function CreateInterstateJob(props) {
  const classes = CreateJobStyle();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [state, dispatch] = useStore();
  const history = useHistory();

  // API calling to add job
  const formik = useFormik({
    initialValues: schema.createInterstateJobSchema,
    validationSchema: validationSchema.createInterstateJobValidationSchema,
    onSubmit: (value) => {
      let data = {
        customerId: value.customerId,
        isPreloadChargeApplied: value.isPreloadChargeApplied,
        pickUpCityId: value.pickUpCityId,
        pickUpLocationType: value.pickUpLocationType,
        pickUpLatitude: value.pickUpLatitude,
        pickUpLongitude: value.pickUpLongitude,
        dropOffCityId: value.dropOffCityId,
        dropOffLocationType: value.dropOffLocationType,
        dropOffLatitude: value.dropOffLatitude,
        dropOffLongitude: value.dropOffLongitude,
      };
      data = {
        ...data,
        ...(!!value.pickUpCtoId ? { pickUpCtoId: value.pickUpCtoId } : {}),
        ...(!!value.pickUpLocation ? { pickUpLocation: value.pickUpLocation } : {}),
        ...(!!value.dropOffCtoId ? { dropOffCtoId: value.dropOffCtoId } : {}),
        ...(!!value.dropOffLocation ? { dropOffLocation: value.dropOffLocation } : {}),
        ...(!!value.requesterName ? { requesterName: value.requesterName } : {}),
        ...(!!value.driverId ? { driverId: value.driverId } : {}),
        ...(!!value.description ? { description: value.description } : {}),

      };

      dispatch({ type: CREATE_INTERSTATE_JOB });
      API.post("interstateJobs", data)
        .then((response) => {
          dispatch({
            type: CREATE_INTERSTATE_JOB_SUCCESS,
            payload: response.data.data,
          });
          history.push(`${routes.interstateJobDetail}/${response?.data?.data?.id}`);
          handleClose();
          if (formik.values.driverId) {
            toast.success("Job created successfully");
          } else {
            toast.success("Job created in the pool");
          }
        })
        .catch((error) => {
          dispatch({ type: CREATE_INTERSTATE_JOB_FAILURE, payload: error });
          setError(error.response.data.message);
        });
    },
  });

  // API calling when create job popup opens
  useEffect(() => {
    if (open) {
      if (state?.common?.countriesData === null) {
        dispatch({ type: GET_CITIES });
        API.get("master/cities")
          .then((response) => {
            dispatch({
              type: GET_CITIES_SUCCESS,
              payload: response.data.data,
            });
          })
          .catch((error) => {
            dispatch({ type: GET_CITIES_FAILURE, payload: error });
          });
      }

      dispatch({ type: FETCH_DRIVERS });
      API.get("drivers", {
        params: {
          order: "ASC",
          orderBy: "driverName",
          filter: { active: true },
          isInterstate: !!props.isInterstate
        }
      })
        .then((response) => {
          dispatch({
            type: FETCH_DRIVERS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({ type: FETCH_DRIVERS_FAILURE, payload: error });
        });

      dispatch({ type: FETCH_CUSTOMERS });
      API.get("customers", {
        params: {
          orderBy: "name",
          order: "asc",
          filter: { parent: 0, status: true },
        },
      })
        .then((response) => {
          dispatch({
            type: FETCH_CUSTOMERS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({ type: FETCH_CUSTOMERS_FAILURE, payload: error });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (formik.values.pickUpCityId && formik.values.pickUpLocationType === '2') {
      const params = {
        cityId: formik.values.pickUpCityId,
      };
      dispatch({type: FETCH_PICK_UP_CTOS});
      API.get("master/ctos", {params})
        .then((response) => {
          dispatch({
            type: FETCH_PICK_UP_CTOS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({type: FETCH_PICK_UP_CTOS_FAILURE, payload: error});
        });
    }
  }, [formik.values.pickUpCityId, formik.values.pickUpLocationType]);

  useEffect(() => {
    if (formik.values.dropOffCityId && formik.values.dropOffLocationType === '2') {
      const params = {
        cityId: formik.values.dropOffCityId,
      };
      dispatch({type: FETCH_DROP_OFF_CTOS});
      API.get("master/ctos", {params})
        .then((response) => {
          dispatch({
            type: FETCH_DROP_OFF_CTOS_SUCCESS,
            payload: response.data.data,
          });
        })
        .catch((error) => {
          dispatch({type: FETCH_DROP_OFF_CTOS_FAILURE, payload: error});
        });
    }
  }, [formik.values.dropOffCityId, formik.values.dropOffLocationType]);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    formik.handleReset();
    setError("");
  };

  const handleChange = (address, type) => {
    type === "pickUpLocation"
      ? formik.setFieldValue("pickUpLocation", address)
      : formik.setFieldValue("dropOffLocation", address);
  };

  // Handle lat/long and address of google place api
  const handleSelect = (address, type) => {
    type === "pickUpLocation"
      ? formik.setFieldValue("pickUpLocation", address)
      : formik.setFieldValue("dropOffLocation", address);
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        return type === "pickUpLocation"
          ? (formik.setFieldValue("pickUpLatitude", latLng.lat),
            formik.setFieldValue("pickUpLongitude", latLng.lng))
          : (formik.setFieldValue("dropOffLatitude", latLng.lat),
            formik.setFieldValue("dropOffLongitude", latLng.lng));
      })
      .catch((error) => console.error("Error", error));
  };

  return (
    <div className={classes.CreateJobWrapper}>
      {getPermissions() &&
          isRolePermission(getPermissions(), "job") &&
          actionFromPermission(getPermissions(), "job") !== actionPermission.READ_ONLY && (
      <Button
        className="orange-btn primary-btn"
        color="inherit"
        disableElevation
        onClick={handleClickOpen}
      >
        + CREATE JOB
      </Button>)}
      <Popup
        open={open}
        handleClose={handleClose}
        formik={formik}
        handleChange={handleChange}
        handleSelect={handleSelect}
        error={error}
      />
    </div>
  );
}

export default CreateInterstateJob;
